module.exports = __webpack_public_path__ + "static/media/gap_yr_com_college.f086ef48.jpg";